export default __webpack_public_path__ + "static/media/share.e3fe5c5d.svg";